class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector('.product-grid');
    this.form = document.querySelector('.filters-form');
    this.dropdownButtons = document.querySelectorAll('.filter-bar__dropdown-button');
    this.filterButtons = document.querySelectorAll('.filter-bar__filter-button');
    this.activeTagsContainer = this.querySelectorAll('.filter-bar__active-filters');

    this.mobileOverlay = document.querySelector('.filters__mobile-overlay');
    this.openMobileFilterButtons = document.querySelectorAll('.js-open-mobile-filters');
    this.closeMobileFilterButtons = document.querySelectorAll('.js-close-mobile-filters');

    this.setListeners();
  }

  setListeners() {
    // Handle Dropdown Click
    this.addEventListener('click', event => {
      const button = event.target.closest('.filter-bar__dropdown-button');
      if (button) {
        event.preventDefault();
        this.handleDropdownClick(button);
      }
    });

    // Handle Form Change
    this.form.addEventListener('change', event => {
      if (event.target.classList.contains('sort-by')) {
        this.handleSortClick(event.target);
      } else {
        this.handleFilterClick(event.target);
      }
    });

    // Handle Remove Filter
    this.activeTagsContainer.forEach(container => {
      container.addEventListener('click', event => {
        const button = event.target.closest('.remove-filter');
        
        if (button) {
          event.preventDefault();
          console.log('asdfjklasdjk')
          const filter = button.dataset.filter;
          const initial = button.dataset.url;
          const newUrl = window.location.protocol + '//' + window.location.host + initial;
    
          this.removeSelectedFilter(filter);
          this.reloadSections(newUrl);
          this.closeAllDropdowns();
        }
      });
    });

    // Clear All Filters
    this.addEventListener('click', event => {
      const button = event.target.closest('.js-clear-all-filters');
      if (button) {
        event.preventDefault();
        this.clearAllFilters();
      }
    });

    // Mobile open
    this.openMobileFilterButtons.forEach(filter => {
      filter.addEventListener('click', event => {
        event.preventDefault();
        this.openMobileFilters();
      });
    });

    // Mobile close
    this.closeMobileFilterButtons.forEach(filter => {
      filter.addEventListener('click', event => {
        event.preventDefault();
        this.closeMobileFilters();
      });
    });
  }

  handleDropdownClick(dropdown) {
    if ($(dropdown).hasClass('active')) {
      $(dropdown).siblings('.filter-bar__dropdown-container').slideUp(300);
      $(dropdown).removeClass('active');
    } else {
      $(dropdown).addClass('active');
      $(dropdown).siblings('.filter-bar__dropdown-container').slideDown(300);
    }
  }

  handleFilterClick() {
    this.closeAllDropdowns();
    this.reloadSections();
  }

  removeSelectedFilter(filter) {
    document.querySelector(`.filter-bar__filter-button[name="${filter}"]:checked`).checked = false;
  }

  handleSortClick() {
    const sort = event.currentTarget.value;
    this.sortBy = sort;
    
    this.closeAllDropdowns();
    this.reloadSections();
  }

  closeAllDropdowns() {
    this.dropdownButtons.forEach(button => {
      if (button.classList.contains('active')) {
        button.classList.remove('active');
      }
    });
  }

  clearAllFilters() {
    event.preventDefault();

    [...document.querySelectorAll('.filter-bar__filters .filter-bar__filter-button')].forEach(item => {
      item.removeAttribute('checked');
    });

    this.closeAllDropdowns();
    this.reloadSections();

    document.querySelector('.filter-bar__left').classList.remove('active');
    document.querySelector('.filters__mobile-overlay').classList.remove('active');
  }

  reloadSections() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    
    const url = location.pathname + '?' + searchParams;

    if (history.replaceState) {
      window.history.pushState({ path: url }, '', url);
    }

    // Fetch and replace sections
    this.enableLoading();
    fetch(location.pathname + '?' + searchParams)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const htmlContent = new DOMParser().parseFromString(html, 'text/html');

        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(section.id).innerHTML;
        }));
      
        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      { id: 'product-grid' },
      { id: 'active-filters' },
      { id: 'filter-dropdowns' },
      { id: 'product-results' },
      { id: 'filter-title' },
      { id: 'mobile-filter-dropdown-count' },
      { id: 'active-filters-mobile' }
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    this.grid.classList.add('loading');
  }

  disableLoading() {
    this.grid.classList.remove('loading');
  }

  openMobileFilters() {
    document.querySelector('.filter-bar__filters-wrapper').classList.add('active');
    this.mobileOverlay.classList.add('active');
    document.body.classList.add('scroll-lock');

    this.mobileOverlay.addEventListener('click', event => {
      this.closeMobileFilters();
    });
  }

  closeMobileFilters() {
    document.querySelector('.filter-bar__filters-wrapper').classList.remove('active');
    document.body.classList.remove('scroll-lock');
    this.mobileOverlay.classList.remove('active');
  }
}

customElements.define('collection-filters', CollectionFilters);

// Sort dupe
$('.collection-wrapper').on('click', '.sort__dropdown-button', (event) => {
  event.preventDefault();
  
  if ($(event.currentTarget).hasClass('active')) {
    $(event.currentTarget).siblings('.sort__dropdown-container').fadeOut(300);
    $(event.currentTarget).removeClass('active');
  } else {
    $(event.currentTarget).addClass('active');
    $(event.currentTarget).siblings('.sort__dropdown-container').fadeIn(300);
  }
});

$('.collection-wrapper').on('click', '.sort__dropdown-container label', (event) => {
  $('.sort__dropdown-container').fadeOut(300);
  $('.sort__dropdown-button').removeClass('active');
});

// Mini Nav Active Event
$('.collection-header .link-button ul.btn-list li, .secondary-button ul.btn-list li').on('click', function () {
  if($('.collection-header .link-button ul.btn-list li.active, .secondary-button ul.btn-list li.active')) {
    $('.collection-header .link-button ul.btn-list li.active, .secondary-button ul.btn-list li.active').removeClass("active");
  }
  $(this).addClass("active");
});